export default __webpack_public_path__ + "static/media/tdBank.b9296393.png";